import React, { useState } from "react";
import "../../../static/css/App.css";
import OrderTable from "../orderTable";
const DeliveredOrders = () => {
  return (
    <>
      <OrderTable status={6} isActive="delivered" />
    </>
  );
};

export default DeliveredOrders;
